import { useNavigate } from "react-router-dom";

export const useGoToAddr = () => {
  const navigate = useNavigate();

  const goToAddr = (addr) => {
    navigate(`/${addr}`);
  };

  return goToAddr;
};
